<template>

  <div class="admin-body">
    <el-row>
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>财务管理</el-breadcrumb-item>
        <el-breadcrumb-item>统计</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>
    <el-row style="padding: 15px">
      <el-row class="main">
        <el-row :gutter="10" style="min-height: 40px">
          <el-col :span="24" align="right">
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24"></el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="6" style="margin-bottom: 5px"  align="left">
<!--          <el-date-picker-->
<!--          style="width: 100%"-->
<!--          v-model="sstime"-->
<!--          type="daterange"-->
<!--          align="right"-->
<!--          unlink-panels-->
<!--          range-separator="至"-->
<!--          start-placeholder="开始日期"-->
<!--          end-placeholder="结束日期"-->
<!--          :picker-options="pickerOptions"-->
<!--          >-->
<!--          </el-date-picker>-->
            <el-date-picker
              format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              @change="dateChange"
              v-model="selectDate"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24"  style="margin-top: 15px">
            <el-card class="box-card">
              <div slot="header" class="clearfix" style="font-size: 18px">
                总收入金额<span style="color: #409EFF;margin-left: 10px">{{totalPrice.toFixed(2)}}</span>
<!--                <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button>-->
              </div>
              <div  class="box-card-text item">
                <el-row :gutter="20">
                  <el-col :span="24">
                    <div class="grid-content bg-purple" style="color: #409EFF">
                    <el-row :gutter="20">
                    <el-col :span="8"><div class="grid-content bg-purple" style="color: #409EFF"><p>支付宝收入</p>{{tableData.income.app_alipay}}</div></el-col>
                    <el-col :span="8"><div class="grid-content bg-purple" style="color: #409EFF"><p>微信收入</p>{{tableData.income.app_wx}}</div></el-col>
                    <el-col :span="8"><div class="grid-content bg-purple" style="color: #409EFF"><p>余额收入</p>{{tableData.income.app_balance}}</div></el-col>
                    </el-row>
                  </div>
                  </el-col>

               </el-row>
              </div>
              <div  class="box-card-text item">
                <el-row :gutter="20">
                  <el-col :span="8"><div class="grid-content bg-purple" style="color: #409EFF"><p style="color: #409EFF;font-size: 18px">APP会员</p>
                    <el-row :gutter="20">
                      <el-col :span="6"><div class="grid-content bg-purple" style="color: #409EFF"><p>开通次数</p>{{tableData.member123.open_quantity}}</div></el-col>
                      <el-col :span="6"><div class="grid-content bg-purple" style="color: #409EFF"><p>开通总金额</p>{{tableData.member123.open_money}}</div></el-col>
                      <el-col :span="6"><div class="grid-content bg-purple" style="color: #409EFF"><p>续费次数</p>{{tableData.member123.renew_quantity}}</div></el-col>
                      <el-col :span="6"><div class="grid-content bg-purple" style="color: #409EFF"><p>续费总金额</p>{{tableData.member123.renew_money}}</div></el-col>

                    </el-row>
                  </div>
                  </el-col>
              <el-col :span="8"><div class="grid-content bg-purple" style="color: #409EFF"><p style="color: #409EFF;font-size: 18px">兑换码会员</p>
                    <el-row :gutter="20">
                      <el-col :span="12"><div class="grid-content bg-purple" style="color: #409EFF"><p>开通次数</p>{{tableData.member4.open_quantity}}</div></el-col>
                      <el-col :span="12"><div class="grid-content bg-purple" style="color: #409EFF"><p>续费次数</p>{{tableData.member4.renew_quantity}}</div></el-col>

                    </el-row>
                  </div>
                  </el-col>
        <el-col :span="8"><div class="grid-content bg-purple" style="color: #409EFF"><p style="color: #409EFF;font-size: 18px">渠道会员</p>
                    <el-row :gutter="20">
                      <el-col :span="6"><div class="grid-content bg-purple" style="color: #409EFF"><p>开通次数</p>{{tableData.member5.open_quantity}}</div></el-col>
                      <el-col :span="6"><div class="grid-content bg-purple" style="color: #409EFF"><p>续费次数</p>{{tableData.member5.renew_quantity}}</div></el-col>
                      <el-col :span="6"><div class="grid-content bg-purple" style="color: #409EFF"><p>注销会员次数</p>{{tableData.member5.un_open_quantity}}</div></el-col>
                      <el-col :span="6"><div class="grid-content bg-purple" style="color: #409EFF"><p>扣减期限次数</p>{{tableData.member5.un_renew_quantity}}</div></el-col>

                    </el-row>
                  </div>
                  </el-col>

                </el-row>
              </div>
              <div  class="box-card-text item">
                <el-row :gutter="20">
                  <el-col :span="6"><div class="grid-content bg-purple" style="color: #409EFF"><p style="color: #409EFF;font-size: 18px">购买头像</p>
                    <el-row :gutter="20">
                      <el-col :span="12"><div class="grid-content bg-purple" style="color: #409EFF"><p>购买次数</p>{{tableData.headimg.quantity}}</div></el-col>
                      <el-col :span="12"><div class="grid-content bg-purple" style="color: #409EFF"><p>购买金额</p>{{tableData.headimg.money}}</div></el-col>


                    </el-row>
                  </div>
                  </el-col>
                  <el-col :span="6"><div class="grid-content bg-purple" style="color: #409EFF"><p style="color: #409EFF;font-size: 18px">用户收益金额</p>
                    <el-row :gutter="20">
                      <el-col :span="12"><div class="grid-content bg-purple" style="color: #409EFF"><p>提成收益</p>{{tableData.income_user.commission}}</div></el-col>
                      <el-col :span="12"><div class="grid-content bg-purple" style="color: #409EFF"><p>分红收益</p>{{tableData.income_user.bonus}}</div></el-col>

                    </el-row>
                  </div>
                  </el-col>
                  <el-col :span="6"><div class="grid-content bg-purple" style="color: #409EFF"><p style="color: #409EFF;font-size: 18px">提成</p>
                    <el-row :gutter="20">
                      <el-col :span="8"><div class="grid-content bg-purple" style="color: #409EFF"><p>已完成</p>{{tableData.withdrawal.complete}}</div></el-col>
                      <el-col :span="8"><div class="grid-content bg-purple" style="color: #409EFF"><p>申请中</p>{{tableData.withdrawal.apply}}</div></el-col>
                      <el-col :span="8"><div class="grid-content bg-purple" style="color: #409EFF"><p>已拒绝</p>{{tableData.withdrawal.refuse}}</div></el-col>

                    </el-row>
                  </div>
                  </el-col>
    <el-col :span="6"><div class="grid-content bg-purple" style="color: #409EFF"><p style="color: #409EFF;font-size: 18px">毛利润</p>
                    <el-row :gutter="20">
                      <el-col :span="24"><div class="grid-content bg-purple" style="color: #409EFF"><p>毛利润</p>{{(totalPrice-tableData.income_user.commission).toFixed('2')}}</div></el-col>

                    </el-row>
                  </div>
                  </el-col>

                </el-row>
              </div>
            </el-card>
          </el-col>
<!--          <el-col :xs="24" :sm="24" :md="12" :lg="12" style="margin-top: 15px">-->
<!--            <el-card class="box-card">-->
<!--              <div slot="header" class="clearfix">-->
<!--                <span>提成</span><br>-->
<!--                <span>(一级+二级+股东分红)</span>-->
<!--                &lt;!&ndash;<el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button>&ndash;&gt;-->
<!--              </div>-->
<!--              <div  class="box-card-text item">-->
<!--                <el-row :gutter="20">-->
<!--                  <el-col :span="12"><div class="grid-content bg-purple" style="color: #409EFF"><p  style="color: #409EFF">已提现</p> 12345</div></el-col>-->
<!--                  <el-col :span="12"><div class="grid-content bg-purple" style="color: #409EFF"><p  style="color: #409EFF">未提现</p>123456</div></el-col>-->
<!--                  </el-row>-->
<!--              </div>-->
<!--            </el-card>-->
<!--          </el-col>-->
<!--          <el-col :xs="24" :sm="24" :md="12" :lg="12" style="margin-top: 15px">-->
<!--            <el-card class="box-card">-->
<!--              <div slot="header" class="clearfix">-->
<!--                <span>毛利润</span><br>-->
<!--                <span style="color: white">1</span>-->
<!--                &lt;!&ndash;<el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button>&ndash;&gt;-->
<!--              </div>-->
<!--              <div  class="box-card-text item">-->
<!--                <el-row :gutter="20">-->
<!--                  <el-col><div class="grid-content bg-purple" style="color: #409EFF"><p  style="color: #409EFF">毛利润</p>121221</div></el-col>-->
<!--                </el-row>-->
<!--              </div>-->
<!--            </el-card>-->
<!--          </el-col>-->

        </el-row>
      </el-row>
    </el-row>



    <template><span v-loading.fullscreen.lock="fullscreenLoading"></span></template>
  </div>
</template>

<script>

  export default {
    name: "FinanceAmount",
    mounted() {
      if(!this.$store.state.login.in){
        this.$router.push({ name: "login", params: { userId: 123 }})
      }
      this.getstart();
      // this.getArea()
    },
    data() {
      return {
        selectDate:[],
        deletemoredata:[],
        deleteMoreOrderdata:[],
        ODcurrentPage:1,
        ODpagesize:10,
        ODdatatotal:0,
        detailsOrderData:[],
        DetailsVisible:false,
        AmountType: [{
          value: '1',
          label: '充值金额统计'
        }, {
          value: '2',
          label: '实收金额统计'
        }, {
          value: '3',
          label: '返现金额统计'
        }],
        AmountTypevalue: '',
        pickerOptions: {
          shortcuts: [{
            text: '昨天',
            onClick(picker) {
              const start = new Date();
              start.setTime(start.getTime()-3600 * 1000 * 24);
              picker.$emit('pick', [start, start]);
            }
          },{
            text: '前天',
            onClick(picker) {
              const start = new Date();
              start.setTime(start.getTime()-3600 * 1000 * 24*2);
              picker.$emit('pick', [start, start]);
            }
          }
            ,{
              text: '最近一周',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: '最近三个月',
              onClick(picker) {
                const end = new Date();
                const start = new Date();/* 获取系统当前时间*/
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90); /* getTime（）1970.1.1至今毫秒数。setTime（x）给start添加x毫秒*/
                picker.$emit('pick', [start, end]);
              }
            }],
        },
        watchdata: [{
          watch_id: 'addtime desc',
          watch_name: '按提现时间降序'
        }, {
          watch_id: 'addtime asc',
          watch_name: '按提现时间升序'
        }],
        watch_value: '按提现时间降序',
        watch:'',
        fullscreenLoading: false,
        tableData: [],
        totalPrice:'',
        pagesize:10,
        currentPage:1,
        selectkey:'',
        datatotal:0,
        sstime:[],
        addtime1:'0000000000',
        addtime2:'9999999999',
        addtimeop:0,
        areaValue:'',
        excelData:[],
        excelTitleData:['注册时间','提现金额','用户名','手机号','类型'],
        excelClick:false,
      }
    },
    watch:{

      sstime(){
        let thi = this
        if(thi.addtimeop==0){
          // thi.addtimeop=1
          console.log(thi.sstime)
          if(thi.sstime){
            // console.log(thi.sstime.length)
            if (typeof(thi.sstime[0])=='number'){
              thi.addtime1 = Math.floor(thi.sstime[0]/1000)
              thi.addtime2 = Math.floor(thi.sstime[1]/1000)
            } else {
              thi.addtime1 = Math.floor(thi.sstime[0].getTime()/1000)
              thi.addtime2 = Math.floor(thi.sstime[1].getTime()/1000)
            }
          }else {
            thi.addtime1='0000000000'
            thi.addtime2='9999999999'
          }
          thi.getstart()
        }
        console.log(thi.addtime1,thi.addtime2)
      }
    },
    methods: {
      sum(){
        var s = 0;

        for (var i=arr.length-1; i>=0; i--) {

          s += arr[i];

        }

        return s;
      },
      dateChange() {

        if (!this.selectDate || this.selectDate.length == 0) {
          this.firstDay = ''
          this.lastDay = ''

          this.getstart()
          // this.getStart1()
          this.$message({
            type: 'warning',
            message: '请选择年月'
          });
          return;
        };
        if (this.selectDate && this.selectDate.length > 0 && this.selectDate[1]) {
          var date = new Date(this.selectDate[0]);

          // this.yyy = Date.parse(new Date(date))/1000;
          //
          // var date1 = new Date(this.selectDate[1]);
          //
          // this.yyyy = Date.parse(new Date(date1))/1000;
          this.yyy = (Date.parse(new Date(date))/1000)-28800;

          var date1 = new Date(this.selectDate[1]);
// 57400
          this.yyyy = (Date.parse(new Date(date1))/1000)+57599;
        }
        // // 结束时间
        // console.log(yyy,  'timestamp')
        // console.log(yyyy,  'timestamp1')

        this.firstDay =this.yyy
        this.lastDay = this.yyyy
        // 开始时间
        console.log(this.firstDay, 'firstDay')
        console.log(this.lastDay, 'lastDay')
        this.getstart()
        // this.getStart1()

      },
      //格式化时间
      formatDate(timeStamp) {
        if(timeStamp==null){
          return ''
        }
        if(timeStamp==''){
          return ''
        }
        console.log(timeStamp,'ttt')
        var date = new Date();
        date.setTime(timeStamp * 1000);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        // var h = date.getHours();
        // h = h < 10 ? ('0' + h) : h;
        // var minute = date.getMinutes();
        // var second = date.getSeconds();
        // minute = minute < 10 ? ('0' + minute) : minute;
        // second = second < 10 ? ('0' + second) : second;
        return y + '-' + m + '-' + d ;
      },
      //绑定表格数据，分页
      getstart() {
        let thi = this
        thi.fullscreenLoading = true
        /*全屏幕正在加载*/
        const prams = {
          // page: thi.currentPage, /*当前页码*/
          // pageSize: thi.pagesize, /*每页显示多少条数据*/
          // key: thi.selectkey, /*名字或电话查询字符串*/
          startTime: thi.formatDate(thi.firstDay),
          endTime: thi.formatDate(thi.lastDay),
          // sort_by: this.watch,
        }
        console.log(prams)
        this.$http.post(global.posturl.host + global.posturl.Statistics, prams
        ).then(function (response) {
          console.log(response.data)
          var qcode = response.data.code
          var qmsg = response.data.msg
          var qdata = response.data.data
          var qtotal = response.data.Total
          if (qcode == 200) {
            thi.tableData = qdata

            // for(let i =0;i<qdata.income.length;i++){
           thi.totalPrice = Number((qdata.income.app_alipay).replace(/[,]/g,"")) + Number((qdata.income.app_wx).replace(/[,]/g,"")) + Number((qdata.income.app_balance).replace(/[,]/g,""))

            // }
            console.log(Number((qdata.income.app_alipay).replace(/[,]/g,"")))
            console.log(Number((qdata.income.app_wx).replace(/[,]/g,"")))
            console.log(Number((qdata.income.app_balance).replace(/[,]/g,"")))
            console.log(thi.totalPrice,'hh')
            /* 绑定表格数据*/
            thi.datatotal = qtotal
            /*总条目数*/
          }
          thi.fullscreenLoading = false
          /*全屏幕正在加载*/
        }).catch(function (error) {
          console.log(error)
        });
      },
      // Excel导出
      exportExcel(){
        let thi= this
        const por={
          area_user_id:thi.areaValue,
          key: thi.selectkey, /*名字或电话查询字符串*/
          starttime: thi.addtime1,
          stoptime: thi.addtime2,
          sort_by: this.watch,
        }
        thi.mySelectAll('memberWithdraws',por).then(function (value) {
          thi.excelData=value.data
          thi.excelClick=true
        })
      },
      //显示订单详情
      showOrderDetails(data){
        this.DetailsVisible=true
        this.getOrderDetails(data.blog_id)
      },
      //获取订单详情
      getOrderDetails(aid){
        console.log(aid)
        let thi = this
        thi.fullscreenLoading = true
        this.$http.post(global.posturl.host + global.posturl.blogCommentsList, {
          page : thi.ODcurrentPage,
          pageSize : thi.ODpagesize,
          // key: thi.PLselectkey,
          blog_id : aid,
        }).then(function (response) {
          console.log(response.data)
          var qcode = response.data.code
          var qmsg = response.data.msg
          var qdata = response.data.data
          var qtotal = response.data.Total
          if(qcode==200){
            thi.detailsOrderData=qdata;
            thi.ODdatatotal=qtotal;
          }
          thi.fullscreenLoading = false
        }).catch(function (error) {
          console.log(error)
        });
      },
      /* 选择多个删除框*/
      deletemore(val) {
        this.deletemoredata = val;
      },
      /* 拼接多个删除id*/
      deletemoreid(rows) {
        if (this.deletemoredata.length == 0) {
          this.$message({
            type: 'warning',
            message: '请选择要删除的分类!'
          });
          return
        } else {
          var ids = '';
          this.deletemoredata.forEach(function (morevalue, moreindex, morearr) {
            if (moreindex == 0) {
              ids = morevalue.blog_id
            } else {
              ids += ',' + morevalue.blog_id
            }
          })
          this.changevaluestate(ids)
        }
      },
      //提示删除用户信息
      changevaluestate(id) {
        console.log(id)
        var heeh = '该'
        if (id.length > 1) {
          heeh = '这些'
        }
        let thi = this
        thi.$confirm('此操作将删除' + heeh + '信息, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error'
        }).then(() => {
          thi.deletevalue(id)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      //执行 删除用户信息
      deletevalue(deleteid) {
        let thi = this
        thi.$http.post(global.posturl.host + global.posturl.deletBlog, {
          blog_id: deleteid,
        }).then(function (response) {
          // console.log(response.data)
          var qcode = response.data.code
          var qmsg = response.data.msg
          var qdata = response.data.data
          if (qcode == 200) {
            thi.$message({
              type: 'success',
              message: qmsg
            });
          }
          else {
            thi.$message({
              type: 'warning',
              message: qmsg
            });
          }
          thi.getstart()
        }).catch(function (error) {
          console.log(error)
        })
      },
      /* 拼接多个订单删除*/
      deleteMoreOrder(val) {
        this.deleteMoreOrderdata = val;
      },
      /* 删除多个信息，拼接多个用户ID*/
      deletemoreOrderID(snumber) {
        var heeh='删除'
        if (snumber==2) {
          heeh = '禁用'
        }
        if (this.deleteMoreOrderdata.length == 0) {
          this.$message({
            type: 'warning',
            message: '请选择要'+heeh+'的分类!'
          });
          return
        } else {
          var ids = '';
          this.deleteMoreOrderdata.forEach(function (morevalue, moreindex, morearr) {
            if (moreindex == 0) {
              ids = morevalue.id
            } else {
              ids += ',' + morevalue.id
            }
          })
          this.toChangeOrders(ids)
        }
      },
      //提示删除评论
      toChangeOrders(id) {
        var heeh = '该'
        if (id.length > 1) {
          heeh = '这些'
        }
        let thi = this
        thi.$confirm('此操作将删除'+heeh + '信息, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error'
        }).then(() => {
          thi.changeComments(id)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      //删除评论
      changeComments(cid){
        console.log(cid)
        let thi = this
        thi.$http.post(global.posturl.host + global.posturl.blogCommentsDelete, {
          id: cid,
        }).then(function (response) {
          // console.log(response.data)
          var qcode = response.data.code
          var qmsg = response.data.msg
          var qdata = response.data.data
          if (qcode == 200) {
            thi.$message({
              type: 'success',
              message: qmsg
            });
          } else {
            thi.$message({
              type: 'warning',
              message: qmsg
            });
          }
          thi.getstart()
        }).catch(function (error) {
          console.log(error)
        })
      },
      //评论页选择展示数量
      ODhandleSizeChange(val) {
        this.ODpagesize=val
        this.getstart()
      },
      //评论分页跳转页面
      ODhandleCurrentChange(val) {
        this.ODcurrentPage=val
        this.getstart()
      },
      //排序
      sorting(watchid) {
        this.watch = watchid
        this.getstart()
      },

      //选择展示数量
      handleSizeChange(val) {
        this.pagesize=val
        this.getstart()
      },
      //跳转页面
      handleCurrentChange(val) {
        this.currentPage=val
        this.getstart()
      },

      //类型转换
      statetype(type){
        switch (type) {
          case 0:
            return '待支付'
          case 1:
            return '代发货'
          case 2:
            return '待收货'
          case 3:
            return '已完成'
          case 4:
            return '已取消'
          default:
            return ''
        }
      },
    }
  }
</script>

<style scoped>
  .admin-body{
    /*background-color: white;*/
    width: 100%;
  }
  .main{
    background-color: white;
    min-height: 500px;
    padding: 10px;
    border: #EDEDED 1px solid;
    border-radius: 5px;
  }
  .block{
    text-align: left;
  }
  .schedule{
    width: 100%;
    padding: 15px 25px;
    box-sizing: border-box;

  }
  .schedule .item{
    width: 100%;
    height: 80px;
    padding: 0 20px;
    box-sizing: border-box;
    border-left: 1px solid #909399;
    position: relative;
  }
  .schedule .item .dot{
    width: 16px;
    height: 16px;
    border-radius: 99px;
    background-color: #909399;
    position: absolute;
    top: 0px;
    left: -8px;
  }
  .schedule .item:first-child{
    border-left: 1px solid #67C23A;
    color: #67C23A;
  }
  .schedule .item:first-child .dot{
    background-color: #67C23A;
  }
  .schedule .info{
    font-size: 14px;

  }
  .schedule .time{
    font-size: 12px;
    margin-top: 10px;
  }
  .text {
    font-size: 14px;
  }

  .item {
    margin-bottom: 18px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }

  .box-card {
    /*width: 90%;*/
  }
  .box-card-text{

  }
  .el-row {
    margin-bottom: 20px;
  }
  .el-row:last-child {
    margin-bottom: 0;
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #f5f5f5;
  }
  .bg-purple {
    background: #f5f5f5;
  }
  .bg-purple-light {
    background: #f5f5f5;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
    padding: 5px 0;
    box-sizing: border-box;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f5f5f5;
  }
  p{margin: 0;
    padding: 0;
  font-size: 14px;
  line-height: 30px;
  color: black}
</style>



// WEBPACK FOOTER //
// src/page/finance/FinanceAmount.vue